export enum MeasurementValueTypeLinear {
  trafficSpeed,
  trafficFlow,
  travelTimeInformation,
  trafficStatusInformation
}

export enum MeasurementValueTypePoint {
  trafficSpeed,
  trafficFlow
}

export enum MeasurementValueTypePointVri {
  trafficSpeed,
  trafficFlow,
  trafficStatusInformation
}



// WEBPACK FOOTER //
// ./src/app/models/enums/measurementvaluetype.ts